<template>
    <div class="col-12">
        <div class="text-right">
            <div class="viewing-buttons d-none d-md-block">
                <p class="d-inline mr-2"><strong>Journey showing on map:</strong></p>
                <button @click="showingMap = 'depart'" :class="getMapButtonClass('depart')"  class="btn journey-btn-type mr-2 ">
                    <strong>Outbound</strong>
                </button>
                <button @click="showingMap = 'return'" :class="getMapButtonClass('return')" class="btn journey-btn-type mr-2">
                   <strong>Return</strong>
                </button>
                <button @click="showingMap = 'both'" :class="getMapButtonClass('both')" class="btn journey-btn-type mr-2">
                   <strong>Both</strong>
                </button>
            </div>
        </div>
        <div class="col-12">
            <loading :isLoading="isLoading"></loading>
            <journey-map class="mt-3" v-if="!isLoading" :journey="currentJourney" :type="showingMap"></journey-map>
        </div>
        <div class="col-12 text-center mt-3">
            <div class="viewing-buttons d-md-none">
                <p><strong>Journey showing on map:</strong></p>
                <button @click="showingMap = 'depart'" class="btn btn-outline-primary journey-btn-type mr-2 ">
                    <strong>Outbound</strong>
                </button>
                <button @click="showingMap = 'return'" class="btn btn-outline-secondary journey-btn-type mr-2">
                   <strong>Return</strong>
                </button>
                <button @click="showingMap = 'both'" class="btn btn-outline-secondary journey-btn-type mr-2">
                    <strong>Both</strong>
                </button>
             </div>
        </div>
    </div>
</template>

<script>
import JourneyMap from '@/components/JourneyMap.vue'
import Loading from '@/components/Loading.vue'
import {
    mapState,
} from 'vuex'

export default {
    components: {
        JourneyMap,
        Loading,
    },
    data() {
        return {
            showingMap: 'depart',
        }
    },
    methods: {
        getMapButtonClass(type) {
            if (this.showingMap === type) {
                return 'btn-outline-primary btn-selected-type'
            }

            return 'btn-outline-secondary'
        },
        showMap(type) {
            if (this.showingMap === type) {
                return true
            }
            return false
        },
    },
    computed: {
        ...mapState([
            'currentJourney',
            'isLoading',
        ]),
    },
}

</script>
